import { postmortemApiEndpoint } from "../../../config";
import errorNotification from "../../Notification/errorNotification";
import { getAuditData } from "../apiPayloadGeneratingFunctions/getAuditData";




export const saveAuditData = async (
    postmortemState,
    postmortemObjectForAuditing,
    postmortemID,
    postAuditData, 
    step,
    updatedBy,
    currentPostmortemObject,
    setCurrentPostmortemObject,
    setPostmortemObjectForAuditing

) => {
  
    console.log("[AUDIT] saveAuditData called - step:", step, "user:", updatedBy);

    let payLoad = {
        "updatedBy": updatedBy,
        "changedFeilds":[],
        "changedData": {
            "postmortemId": postmortemID,
        }
    }



    let auditData = getAuditData(
        postmortemObjectForAuditing,
        postmortemState,
        step,
        currentPostmortemObject,
        setCurrentPostmortemObject,
        setPostmortemObjectForAuditing
    );

    auditData.changedData = {
        ...auditData.changedData,
        "incidentId": currentPostmortemObject.incidentID, 
        "postmortermId": postmortemID,
    }

    payLoad = {
        ...payLoad,
        ...auditData
    }

    console.log("[AUDIT] Audit payload prepared:", {
        updatedBy: payLoad.updatedBy,
        changedFieldsCount: payLoad.changedFeilds?.length || 0,
        changedFields: payLoad.changedFeilds,
        hasChangedData: !!payLoad.changedData
    });

    const apiEndpoint = postmortemApiEndpoint;

    const makeRequest = async () => {
        try {
          console.log("[AUDIT] Making audit-data API call to:", apiEndpoint + '/audit-data');
          console.log("[AUDIT] Payload:", JSON.stringify(payLoad, null, 2));
          
          const apiResponse = await postAuditData(
            apiEndpoint,
            payLoad
          );
    
          console.log("[AUDIT] Audit-data API response status:", apiResponse.status);
          
          if (apiResponse.status === 200 || apiResponse.status === 201 || apiResponse.status === 202) { 
            console.log("[AUDIT] Audit data saved successfully");
            return apiResponse.data
          } else {
            console.error("[AUDIT] Unexpected response status:", apiResponse.status);
            throw new Error("Unknown error");
          }
        } catch (error) {
          console.error("[AUDIT] Error in audit-data API call:", error);
          
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
          }
    
          console.log(error);
          throw error;
        }
      };

    try {
        console.log("[AUDIT] About to call makeRequest()");
        await makeRequest();
        console.log("[AUDIT] makeRequest() completed successfully");

      } catch (error) {
       
        console.error("[AUDIT] Error in saveAuditData:", error);
        errorNotification("Error in saving audit data postmortem data");
        if (error.response && error.response.status === 500) {
          
        } else {
          console.log("Unknown error");
       
          console.error(error);
        }
        throw error;
      }

}